const MARKET_TIME_ZONE_BY_COUNTRY = Object.freeze({
  AU: "Australia/Sydney",
  CA: "America/Toronto",
  DE: "Europe/Berlin",
  FR: "Europe/Paris",
  GB: "Europe/London",
  IN: "Asia/Kolkata",
  JP: "Asia/Tokyo",
  US: "America/New_York",
});

export function normalizeMarketDateCountry(value) {
  const country = String(value || "")
    .trim()
    .toUpperCase()
    .slice(0, 2);
  return MARKET_TIME_ZONE_BY_COUNTRY[country] ? country : "US";
}

export function marketTimeZone(country) {
  return MARKET_TIME_ZONE_BY_COUNTRY[normalizeMarketDateCountry(country)];
}

export function marketLocalDateKey(epochMs = Date.now(), country = "US") {
  try {
    const parts = new Intl.DateTimeFormat("en-CA", {
      timeZone: marketTimeZone(country),
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(new Date(Number.isFinite(epochMs) ? epochMs : Date.now()));
    const values = Object.fromEntries(
      parts.filter((part) => part.type !== "literal").map((part) => [part.type, part.value]),
    );
    return `${values.year}-${values.month}-${values.day}`;
  } catch {
    return new Date(Number.isFinite(epochMs) ? epochMs : Date.now()).toISOString().slice(0, 10);
  }
}

/** Exact delay to the next market-local date, including DST transitions. */
export function nextMarketDateBoundaryDelayMs(epochMs = Date.now(), country = "US") {
  const now = Number.isFinite(epochMs) ? epochMs : Date.now();
  const currentDate = marketLocalDateKey(now, country);
  let low = now;
  let high = now + 36 * 60 * 60 * 1000;
  if (marketLocalDateKey(high, country) === currentDate) return 60 * 60 * 1000;
  while (high - low > 250) {
    const middle = Math.floor((low + high) / 2);
    if (marketLocalDateKey(middle, country) === currentDate) low = middle;
    else high = middle;
  }
  return Math.max(250, high - now + 50);
}
